import React from "react";
import {Icon, styled, Text} from "@reside/ui";

import {RoleNameEnum} from "../../../../utils/types/common";
import {AdminRoles} from "../../../../atoms/admin-roles";
import {FacilityReportingToggle} from "../facility-reporting-toggle";

type Props = Readonly<{
  facilityId: string;
  includeInReporting: boolean;
}>;

/**
 * Full width notice shown above the settings of an inactive facility, with the Reside admin's reporting setting.
 */
export const InactiveFacilityNotice = ({
  facilityId,
  includeInReporting,
}: Props) => (
  <Notice role="status" data-test-id="inactiveFacilityNotice">
    <Icon name="lock" size={16} color="deepOrange100" />
    <Message>
      <Text fontWeight="bold" color="deepOrange100">
        This facility is inactive.
      </Text>{" "}
      <Text color="darkBlue100">
        Its settings can&apos;t be edited and no new workflows can be created in
        it.
      </Text>
    </Message>
    <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
      <FacilityReportingToggle
        facilityId={facilityId}
        includeInReporting={includeInReporting}
      />
    </AdminRoles>
  </Notice>
);

const Notice = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
  margin: -8px 0 24px;
  padding: 12px 16px;
  border: 1px solid ${({theme}) => theme.color.deepOrange100};
  border-left-width: 4px;
  border-radius: 4px;
  background: #fff1f2;
`;

const Message = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;
